import { Image, ImageProps } from '@react-pdf/renderer';
import React from 'react';
import { generateQrCode } from '~/utils/helpers';

const QrCode: React.FC<ImageProps & { qrCodeText: string }> = (props) => {
  const { qrCodeText, ...imageProps } = props;
  const qrCodeURL = React.useMemo(
    async () => await generateQrCode(qrCodeText),
    [qrCodeText],
  );

  return <Image src={qrCodeURL} {...imageProps} />;
};

export default QrCode;
